import _implicitStylesheets from "./favorites.css";
import _implicitScopedStylesheets from "./favorites.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="text${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
const stc1 = {
  "type": "loginNavLink"
};
const stc2 = {
  "lnk-icon": true
};
const stc3 = {
  props: {
    "icon": "heart",
    "size": "medium",
    "ariaHidden": true,
    "spriteUrl": "/images/icons.svg"
  },
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc1,
    key: 1,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("a", {
    classMap: stc2,
    attrs: {
      "href": $cmp.savedListingsUrl,
      "aria-label": $cmp.savedListingsAltLabel,
      "role": "link"
    },
    key: 2
  }, [api_custom_element("ax-icon", _axIcon, stc3), api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text($cmp.savedListingsCount))])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3ese81l7ljs";
tmpl.legacyStylesheetToken = "undefined-_favorites";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
